export default __webpack_public_path__ + "static/media/Group9205.a85b059a.svg";